import React, {useEffect, useContext} from 'react';
import {ViewDataContext} from '../../commons/context/view/ViewDataContext';
import DwellingDataUI from "./DwellingDataUI";
import {FiltersStateContext} from "../../commons/context/FiltersStateContext";
import { FiltersDataContext } from '../../commons/context/FiltersDataContext';
import {getRefreshInterval} from "../../util/CommonUtils";
import {getFeaturesFromParent} from "../../handler/ParentDataHandler";
import {ACTION_TYPE, FEATURES} from "../../commons/constants/CommonConstants";
import {FeatureConfigContext} from "../../commons/context/FeatureConfigContext";
import {chainWalk} from "../../commons/CommonUtils";
import {useDeviceLayout} from "../../commons/context/DeviceLayoutContext";

export const DwellingData = () => {

    const {viewModel, dispatch} = useContext(ViewDataContext)
    const {selectedFilterValues} = useContext(FiltersStateContext)
    const {filtersData} = useContext(FiltersDataContext)
    const {configViewModel, configDispatch} = useContext(FeatureConfigContext)
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let stationCode = params.get('stationCode');
    const {spacingInset_shorthand3} = useDeviceLayout();

    useEffect(() => {
        constructState(selectedFilterValues);
        getFeaturesFromParent([FEATURES.IS_CPT_FILTER_ENABLED]).then(featureStatus => {
            configDispatch({type: ACTION_TYPE.GET_FEATURES_STATUS, featureStatus: featureStatus.data});
        })

        const isCPTFilterEnabled = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_CPT_FILTER_ENABLED], false);
        dispatch({ type: 'LOAD_VIEW', data:{filters: selectedFilterValues , stationCode, view : "DWELLING_VIEW" ,dispatcher: dispatch, leg:"FORWARD", isCPTFilter: isCPTFilterEnabled}});
        const interval = setInterval(() => {
            constructState(selectedFilterValues);
            //check for inactive tabs
            if ( !document.hidden)   
            {     
               dispatch({ type: 'LOAD_VIEW', data:{filters: selectedFilterValues , stationCode, view : "DWELLING_VIEW" ,dispatcher: dispatch, leg:"FORWARD", isCPTFilter: isCPTFilterEnabled}});
           }
    }, getRefreshInterval());
    return () => clearInterval(interval);}, [selectedFilterValues.startPDD, selectedFilterValues.endPDD]);

    return (
        <DwellingDataUI data = {viewModel.metricResult} isCPTFilterEnabled={chainWalk(() => configViewModel.featureStatus[FEATURES.IS_CPT_FILTER_ENABLED], false)} stationTimeZone = {viewModel.stationTimeZone} isLoading = {viewModel.isLoading}
                appliedFilterURL = { selectedFilterValues.appliedFilterURL} filterData= {filtersData} viewTypeForStation = {viewModel.viewTypeForStation} spacingInset_shorthand3={spacingInset_shorthand3}/>
    )
}

const constructState = (selectedFilterValues) => {

    var values = {

        startPDD : selectedFilterValues.startPDD,
        endPDD : selectedFilterValues.endPDD
    }
    //Redirect to search path
    var path = window.location.href.split("dwellingBoard")[0];
    return window.location.replace( path + "dwellingBoard/"+ JSON.stringify(values).replace('/','%2f'));
}


// WEBPACK FOOTER //
// ./src/components/dwelling/DwellingData.js